/* ==========================================================
   Product Gallery Slim JS — PDP only (NO cart code)
   ========================================================== */

(function () {
  if (typeof document === "undefined") return;

  function boot() {
    document.querySelectorAll('[id^="pdp-"]').forEach(initSection);
    initSizeDrawer();
  }

  document.addEventListener("DOMContentLoaded", boot);

  // Shopify theme editor: sections can be re-rendered without reload
  document.addEventListener("shopify:section:load", (e) => {
    const maybe = e.target?.querySelector?.('[id^="pdp-"]');
    if (maybe) initSection(maybe);
    initSizeDrawer();
  });

  /* ---------------- PDP-SECTION ---------------- */
  function initSection(root) {
    if (!root || root.dataset.inited === "1") return;
    root.dataset.inited = "1";

    initGallery(root);
    initVariants(root);
    initQty(root);
    initShare(root);
    dedupePaymentIcons(root);
  }

  /* ---------------- GALLERY ---------------- */
  function initGallery(root) {
    const track  = root.querySelector('[data-track]');
    const thumbs = root.querySelectorAll('[data-thumbs] [data-index]');
    const prev   = root.querySelector('[data-prev]');
    const next   = root.querySelector('[data-next]');

    let index = 0;
    const max = Math.max(0, thumbs.length - 1);

    function setSlide(i) {
      index = Math.max(0, Math.min(max, i | 0));
      if (track) track.style.setProperty("--pg-x", (-100 * index) + "%");
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === max;
      thumbs.forEach((b, idx) => b.setAttribute("aria-current", String(idx === index)));
    }

    thumbs.forEach(b => b.addEventListener("click", () => setSlide(+b.dataset.index)));
    prev?.addEventListener("click", () => setSlide(index - 1));
    next?.addEventListener("click", () => setSlide(index + 1));

    initSwipe(root, () => index, setSlide, max);

    setSlide(0);
  }

  function initSwipe(root, getIndex, setSlide, max) {
    const viewport = root.querySelector(".pg-main");
    const track = root.querySelector("[data-track]");
    if (!viewport || !track || max <= 0) return;
    if (viewport.dataset.swipeInited === "1") return;
    viewport.dataset.swipeInited = "1";

    // allow vertical scroll, intercept horizontal when we lock it
    viewport.style.touchAction = "pan-y";

    let startX = 0, startY = 0;
    let dx = 0, dy = 0;
    let dragging = false;
    let locked = false;
    let startT = 0;

    // Tuned for responsiveness
    const DECIDE = 6;       // px before we decide direction
    const THRESHOLD = 24;   // px to change slide
    const VELOCITY = 0.35;  // px/ms for quick flick
    const SNAP = "transform .28s ease"; // deterministic snap transition

    function setTrackPercent(pct) {
      track.style.setProperty("--pg-x", pct + "%");
    }

    function onDown(e) {
      // Ignore mouse drag (keeps UX consistent)
      if (e.pointerType === "mouse") return;

      dragging = true;
      locked = false;
      dx = dy = 0;

      startX = e.clientX;
      startY = e.clientY;
      startT = performance.now();

      // Remove transition during drag-follow
      track.style.transition = "none";

      try { viewport.setPointerCapture(e.pointerId); } catch (_) {}
      // Prevent browser from “helping” with horizontal gestures
      e.preventDefault();
    }

    function onMove(e) {
      if (!dragging) return;

      dx = e.clientX - startX;
      dy = e.clientY - startY;

      if (!locked) {
        if (Math.abs(dx) < DECIDE && Math.abs(dy) < DECIDE) return;
        locked = Math.abs(dx) > Math.abs(dy) * 1.15;
      }

      if (!locked) return;

      e.preventDefault();

      const index = getIndex();
      const base = -100 * index;
      const dragPct = (dx / viewport.clientWidth) * 100;

      // Rubber band at edges
      let pct = base + dragPct;
      if (index === 0 && dx > 0) pct = base + dragPct * 0.35;
      if (index === max && dx < 0) pct = base + dragPct * 0.35;

      setTrackPercent(pct);
    }

    function onUp() {
      if (!dragging) return;
      dragging = false;

      const index = getIndex();

      // Restore snap transition
      track.style.transition = SNAP;

      if (!locked) {
        // Snap back
        setTrackPercent(-100 * index);
        return;
      }

      const dt = Math.max(1, performance.now() - startT);
      const v = Math.abs(dx) / dt; // px/ms

      if (dx <= -THRESHOLD || (dx < 0 && v > VELOCITY)) setSlide(index + 1);
      else if (dx >= THRESHOLD || (dx > 0 && v > VELOCITY)) setSlide(index - 1);
      else setSlide(index);
    }

    viewport.addEventListener("pointerdown", onDown, { passive: false });
    viewport.addEventListener("pointermove", onMove, { passive: false });
    viewport.addEventListener("pointerup", onUp, { passive: true });
    viewport.addEventListener("pointercancel", onUp, { passive: true });
    viewport.addEventListener("pointerleave", onUp, { passive: true });
  }

  /* ---------------- VARIANTS / ATC ---------------- */
  function initVariants(root) {
    const select     = root.querySelector("[data-variant-select]");
    const radios     = root.querySelectorAll('input[type="radio"][name="id"]');
    const atcButton  = root.querySelector("[data-atc]");
    const customSel  = root.querySelector("[data-custom]");
    const trigger    = customSel?.querySelector("[data-trigger] span");
    const optionsBox = customSel?.querySelector("[data-options]");

    function setATCEnabled(valid) {
      if (!atcButton) return;
      atcButton.disabled = !valid;
      atcButton.setAttribute("aria-disabled", String(!valid));
    }

    function syncVariantSelection(variantId) {
      radios.forEach(r => { r.checked = (r.value === variantId); });
      const valid = !!variantId && [...radios].some(r => r.checked && !r.disabled);
      setATCEnabled(valid);
    }

    // Custom dropdown wired to the native <select>
    if (select && customSel && trigger && optionsBox) {
      const opts = Array.from(select.options);
      optionsBox.innerHTML = opts.map(o => {
        const dis = o.disabled ? ' aria-disabled="true"' : "";
        return `<span class="custom-option" data-value="${o.value}" data-title="${o.text}"${dis}>${o.text}</span>`;
      }).join("");

      const current = select.selectedIndex > -1 ? select.selectedOptions[0] : null;
      trigger.textContent = current ? current.text : (opts[0]?.text || "Choose your size");

      const trigBtn = customSel.querySelector("[data-trigger]");
      trigBtn?.addEventListener("click", () => customSel.classList.toggle("open"));

      document.addEventListener("click", (e) => {
        if (!customSel.classList.contains("open")) return;
        if (!customSel.contains(e.target)) customSel.classList.remove("open");
      });

      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") customSel.classList.remove("open");
      });

      optionsBox.addEventListener("click", (e) => {
        const opt = e.target.closest(".custom-option");
        if (!opt || opt.getAttribute("aria-disabled") === "true") return;

        select.value = opt.dataset.value || "";
        trigger.textContent = opt.dataset.title || "Choose your size";
        syncVariantSelection(select.value);
        select.dispatchEvent(new Event("change", { bubbles: true }));
        customSel.classList.remove("open");
      });

      select.addEventListener("change", () => {
        const sel = select.selectedOptions[0];
        if (sel) trigger.textContent = sel.text;
        syncVariantSelection(select.value);
      });

      if (!select.value) syncVariantSelection("");
      else syncVariantSelection(select.value);

    } else if (select) {
      // Native select only
      select.addEventListener("change", () => syncVariantSelection(select.value));
      syncVariantSelection(select.value || "");
    } else {
      // No variant picker present
      const anyChecked = [...radios].some(r => r.checked && !r.disabled);
      setATCEnabled(anyChecked);
      radios.forEach(r => r.addEventListener("change", () => {
        const v = [...radios].find(x => x.checked)?.value || "";
        syncVariantSelection(v);
      }));
    }
  }

  /* ---------------- QUANTITY ---------------- */
  function initQty(root) {
    const qtyWrap   = root.querySelector("[data-qty], .product-quantity");
    const qtyInput  = root.querySelector("[data-qty-input], input[name='quantity']");
    const qtyValEls = qtyWrap?.querySelectorAll(".quantity-value") || [];
    const minusBtn  = qtyWrap?.querySelector("[data-minus], .quantity-minus");
    const plusBtn   = qtyWrap?.querySelector("[data-plus], .quantity-plus");

    if (!qtyWrap || !qtyInput) return;

    qtyInput.setAttribute("step", "1");
    qtyInput.setAttribute("min", "1");

    function sync(n) {
      const min = parseInt(qtyInput.getAttribute("min") || "1", 10);
      let v = parseInt(n ?? qtyInput.value ?? "1", 10);
      if (isNaN(v) || v < min) v = min;

      qtyInput.value = v;
      qtyValEls.forEach(el => {
        el.textContent = String(v);
        el.setAttribute("data-value", String(v));
      });
      if (minusBtn) minusBtn.disabled = v <= min;
    }

    minusBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      if (minusBtn.disabled) return;
      const cur = parseInt(qtyInput.value || "1", 10) || 1;
      sync(cur - 1);
    }, { capture: true });

    plusBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      const cur = parseInt(qtyInput.value || "1", 10) || 1;
      sync(cur + 1);
    }, { capture: true });

    qtyInput.addEventListener("change", () => sync(qtyInput.value), { capture: true });
    sync(qtyInput.value);
  }

  /* ---------------- SHARE ---------------- */
  function initShare(root) {
    const shareToggle = root.querySelector(".share-section [data-role='toggle']")
                      || root.querySelector(".share-section .share-button[aria-controls='share-icons']");
    const shareBlock  = root.querySelector(".share-section .share-block");
    const wrap        = root.querySelector(".share-section");
    if (!shareToggle || !shareBlock || !wrap) return;

    const ICONS = {
      x: `<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M18.9 2H22l-6.8 7.8L23 22h-6.7l-5.2-6.7L5.2 22H2l7.4-8.5L1 2h6.8l4.7 6.1L18.9 2Zm-1.2 18h1.7L7.2 4H5.4l12.3 16Z"/></svg>`,
      facebook: `<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M13 22v-8h2.7l.4-3H13V8.2c0-.9.3-1.5 1.7-1.5H16V4.1C15.7 4 14.7 4 13.6 4 11 4 9.3 5.4 9.3 7.9V11H7v3h2.3v8H13z"/></svg>`,
      pinterest: `<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12.3 3C7.8 3 5 6 5 9.6c0 2.2 1.2 3.5 2 3.5.3 0 .4-.7.4-.9 0-.3-.5-1-.5-2.3 0-2.7 2-4.6 4.8-4.6 2.3 0 4 1.3 4 3.8 0 1.9-.8 5.4-3.4 5.4-.9 0-1.7-.6-1.7-1.5 0-1.3.9-2.5.9-3.8 0-2.2-3.2-1.8-3.2 1 0 .8.2 1.3.2 1.3s-1 4-1.2 4.7c-.4 1.6-.1 3.6-.1 3.8l.1.1c.1-.1 1.8-2.3 2.3-3.9.2-.8.9-3 .9-3 .4.7 1.4 1.2 2.4 1.2 3.1 0 5.2-2.8 5.2-6.4C18.1 5.4 15.6 3 12.3 3z"/></svg>`,
      copy: `<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M16 1H8c-1.1 0-2 .9-2 2v10h2V3h8V1zm3 4H12c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16h-7V7h7v14z"/></svg>`
    };

    shareBlock.querySelectorAll(".share-button").forEach(btn => {
      const raw = (btn.dataset.sharer || "").toLowerCase();
      const key = raw === "twitter" ? "x" : raw;
      if (!btn.querySelector("svg") && ICONS[key]) btn.innerHTML = ICONS[key];
    });

    const setExpanded = (on) => {
      shareToggle.setAttribute("aria-expanded", String(!!on));
      wrap.classList.toggle("open", !!on);
    };

    shareToggle.addEventListener("click", (e) => {
      e.preventDefault();
      setExpanded(!wrap.classList.contains("open"));
    });

    document.addEventListener("click", (e) => {
      if (!wrap.classList.contains("open")) return;
      if (!wrap.contains(e.target)) setExpanded(false);
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") setExpanded(false);
    });

    shareBlock.addEventListener("click", async (e) => {
      const btn = e.target.closest(".share-button");
      if (!btn) return;

      const url = btn.dataset.url || window.location.href;
      const raw = (btn.dataset.sharer || "").toLowerCase();
      const type = raw === "twitter" ? "x" : raw;

      if (type === "copy") {
        try { await navigator.clipboard.writeText(url); } catch(_) {}
        return;
      }

      const shareUrls = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
        x: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`,
        pinterest: `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}`
      };

      const target = shareUrls[type];
      if (target) window.open(target, "_blank", "noopener,noreferrer,width=600,height=600");
    });
  }

  /* ---------------- PAYMENT ICONS ---------------- */
  function dedupePaymentIcons(root) {
    const lists = root.querySelectorAll("ul.payment-icons");
    if (lists.length > 1) lists.forEach((ul, i) => { if (i > 0) ul.remove(); });

    const mo = new MutationObserver(() => {
      const all = root.querySelectorAll("ul.payment-icons");
      if (all.length > 1) all.forEach((ul, i) => { if (i > 0) ul.remove(); });
    });

    mo.observe(root, { childList: true, subtree: true });
  }

  /* ---------------- SIZE DRAWER (GLOBAL) ---------------- */
  function initSizeDrawer() {
    var drawer = document.getElementById("size-chart-drawer")
             || document.querySelector("[data-size-drawer='1']")
             || document.querySelector(".shopify-section-group-popups-group .size-drawer")
             || document.querySelector(".size-drawer");

    if (!drawer || drawer.dataset.sizeInit === "1") return;
    drawer.dataset.sizeInit = "1";

    var html    = document.documentElement;
    var panel   = drawer.querySelector(".size-wrapper");
    var openers = document.querySelectorAll(".size-guide, [data-open-size-chart]");
    var closers = drawer.querySelectorAll("#closeSize, [data-close-size-chart], .close-btn, [data-close]");

    function setOpen(on) {
      drawer.classList.toggle("is-open", on);
      drawer.classList.toggle("open", on);
      html.classList.toggle("no-scroll", on);
      drawer.setAttribute("aria-hidden", on ? "false" : "true");
    }

    function isOutsidePanel(evt) { return panel && !panel.contains(evt.target); }

    openers.forEach(function (el) {
      el.addEventListener("click", function (e) {
        var href = (el.getAttribute("href") || "").trim();
        var isTrigger =
          el.hasAttribute("data-open-size-chart") ||
          el.classList.contains("size-guide") ||
          href === "" || href === "#";

        if (!isTrigger) return;
        e.preventDefault();
        setOpen(true);
      }, { passive: false });
    });

    closers.forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        setOpen(false);
      }, { passive: false });
    });

    drawer.addEventListener("click", function (e) { if (isOutsidePanel(e)) setOpen(false); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") setOpen(false); });
  }
})();
